import React from "react";
import "./Gdspm.css";

const NEW_PRODUCTS = [
  {
    id: 1,
    qty: 450,
    name: "Set 10 Bao Lì Xì CHIBI",
    price: 4000,
    href: "#",
    img: "/2spm/1.jpeg",
  },
  {
    id: 2,
    qty: 210,
    name: "Set 4 Khánh CHỮ Treo Tường",
    price: 41900,
    href: "#",
    img: "/2spm/2.jpeg",
  },
  {
    id: 3,
    qty: 150,
    name: "Set 2 Khánh Treo Tường DỌC (CMNM-VSNY)",
    price: 33100,
    href: "#",
    img: "/2spm/3.jpeg",
  },
  {
    id: 4,
    qty: 48,
    name: "Hộp Cơm Inox 2 Ngăn CAPYBARA",
    price: 66000,
    href: "#",
    img: "/2spm/4.jpeg",
  },
  {
    id: 5,
    qty: 32,
    name: "Hộp Cơm Nhựa Lunch Box",
    price: 59000,
    href: "#",
    img: "/2spm/5.jpeg",
  },
  {
    id: 6,
    qty: 90,
    name: "Bộ Cọ Rửa Mini",
    price: 12900,
    href: "#",
    img: "/2spm/6.jpeg",
  },
  {
    id: 7,
    qty: 70,
    name: "Móc Treo Đa Năng (Combo)",
    price: 27900,
    href: "#",
    img: "/2spm/7.jpeg",
  },
  {
    id: 8,
    qty: 40,
    name: "Rổ Inox Rửa Rau",
    price: 52000,
    href: "#",
    img: "/2spm/8.jpeg",
  },
];

function formatVND(n) {
  return new Intl.NumberFormat("vi-VN").format(n) + "đ";
}

export default function Gdspm() {
  return (
    <section className="np">
      <div className="np__container">
        <h2 className="np__title">SẢN PHẨM MỚI</h2>

        <div className="np__grid">
          {NEW_PRODUCTS.slice(0, 8).map((p) => (
            <a className="np__card" href={p.href} key={p.id}>
              <div className="np__media">
                <img
                  className="np__img"
                  src={p.img}
                  alt={p.name}
                  loading="lazy"
                />
              </div>

              <div className="np__meta">
                <div className="np__name">
                  <span className="np__qty">[{p.qty}]</span>{" "}
                  <span className="np__nameText">{p.name}</span>
                </div>
                <div className="np__price">{formatVND(p.price)}</div>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}
